import * as React from 'react';

export const YouTubeIcon = () => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="YouTube"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0338 0.35842C16.8087 0.555974 17.4177 1.13594 17.6251 1.87394H17.6236C18 3.21025 18 6 18 6C18 6 18 8.78975 17.6236 10.1261C17.4162 10.8641 16.8072 11.444 16.0323 11.6416C14.6291 12 9 12 9 12C9 12 3.37093 12 1.96773 11.6416C1.19279 11.444 0.5838 10.8641 0.376358 10.1261C0 8.78975 0 6 0 6C0 6 0 3.21025 0.376358 1.87394C0.5838 1.13594 1.19279 0.555974 1.96773 0.35842C3.37093 0 9 0 9 0C9 0 14.6291 0 16.0338 0.35842ZM11.8775 6L7.1997 3.42897V8.57102L11.8775 6Z"
        fill="currentColor"
      />
    </svg>
  );
};
